"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-option" };
const _hoisted_2 = {
    key: 0,
    class: "wf-component-title"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_warnings_component = (0, vue_1.resolveComponent)("warnings-component");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_warnings_component, {
            warnings: _ctx.playerinput.warnings
        }, null, 8, ["warnings"]),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                key: 1,
                size: "big",
                onClick: _ctx.saveData,
                title: _ctx.$t(_ctx.playerinput.buttonLabel)
            }, null, 8, ["onClick", "title"]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
